export const style = `
.wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}
.wrapper svg {
    width: 100%;
}

/* Media queries for different screen sizes */
@media (max-height: 700px) {
    .wrapper svg {
        max-width: 100%;
        max-height: 25em;
        overflow-y: auto;
        overflow-x: auto;
    }
}

.side-by-side-container form.side-by-side-content {
    overflow-y: scroll;
}

.side-by-side-container.no-scroll {
    max-height: 80vh;
}

#asset-tooltip-container {
    display: none;
    padding: 10px;
    background-color: white;
    border: 2px solid black;
    border-radius: 5px;
}

#tooltip-input {
    display: none;
}

#tooltip-select {
    display: none;
}

.ws-liner {
    fill: #CBCBCBB2;
    cursor: pointer;
}

    .ws-liner:hover {
        fill: rgba(0, 75, 255, 0.25);
    }


.ws-liner-mapped {
    fill: rgba(50, 50, 0, 0.25);
}

.ws-hole-mapped {
    fill: rgba(50, 100, 0, 0.25);
}
.ws-liner:hover {
    fill: rgba(0, 75, 255, 0.25);
}

.ws-hole {
    position: relative;
    fill: gold !important;
    stroke: black;
    stroke-width: 1px;
}

    .ws-hole:hover {
        fill: rgba(0, 148, 255, 0.25) ;
    }


.ws-regionTemp {
    fill: rgba(255, 255, 0, 0.4) ;
    stroke: #000000;
    stroke-width: 1.15px;
    stroke-miterlimit: 4;
    stroke-dasharray: 6;
    pointer-events: none;
}

    .ws-regionTemp:hover {
        fill: rgba(0, 220, 255, 0.25);
    }

div#drawing-references svg .ws-hole {
    pointer-events: none;
}

div#commission-sensors svg .ws-liner {
    pointer-events: none;
}


.ws-path-id-changed {
    fill: rgba(200, 50, 200, 0.25)
}

.ws-path-unassigned {
    fill: white;
    stroke: #ff00ff;
    stroke-width: 0.2px;
    stroke-miterlimit: 4;
    stroke-dasharray: 1;
}

    .ws-path-unassigned:hover {
        fill: rgba(255, 0, 255, 0.5);
        fill-opacity: 0.5;
    }

.ws-hole-unassigned {
    fill: white;
    stroke: black;
    stroke-width: 0.2px;
    stroke-miterlimit: 4;
    stroke-dasharray: 1;
}

    .ws-hole-unassigned:hover {
        fill: rgba(255, 0, 255, 0.5);
        fill-opacity: 0.5;
    }

#name-changes-summary {
    max-height: 60vh;
    overflow-y: scroll;
    padding: 5px 20px 5px;
    border: 1px solid grey;
}

.ws-liner-location-assigned {
    fill: rgba(0, 0, 0, 0.5);
}

.li-hoverable {
    list-style-type: none;
}

.li-hoverable:hover {
    background-color: lightblue;
    background-color: rgba(255, 0, 255, 0.5);
    cursor: pointer;
}

.ws-regionTemp-assigned {
    fill: rgba(0, 220, 150, 0.25);
}

.ws-regionTemp-selected {
    fill: rgba(255, 0, 255, 0.5);
}

.ws-hole-selected {
    stroke: black;
    stroke-width: 5px;
}

#assigned-sensors {
    padding-inline-start: 0px;
}


.asset-section-view-right-buttons {
    display: flex !important;
    gap: 0.3em !important;
    font-weight: 400;
}
.asset-section-view-right-buttons ._labelWrapper_1d6p3_1 {
    flex-direction: row !important;
}
    .asset-section-view-right-buttons ._mainContainer_1d6p3_18._outline_1d6p3_25 {
        outline: 2px solid var(--color-themed-primary-7) !important;
    }
    .asset-section-view-right-buttons ._mainContainer_1d6p3_18._small_1d6p3_31 {
        height: 89% !important;
    }
    .asset-section-view-right-buttons ._labelWrapper_1d6p3_1{
        align-items:center
    }
    .asset-section-view-right-buttons ._mainContainer_1d6p3_18 ._menuButton_1d6p3_40 ._contentContainer_1d6p3_61._small_1d6p3_31 {
        min-height: var(--size-l);
        padding: var(--size-xxs) var(--size-s);
    }
   `
